import _defineProperty from '@babel/runtime/helpers/defineProperty';
import theme from '../theme/index.js';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * Creates `webfontloader` instance & loads `Open Sans`.
 *
 * @see https://github.com/typekit/webfontloader
 */
var loadFonts = function (config) {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line global-require,@typescript-eslint/no-var-requires
    var WebFont = require('webfontloader');
    WebFont.load(_objectSpread({
      google: {
        families: ["Open Sans:".concat(Object.values(theme.fontWeights).join(','), "&display=swap")]
      },
      classes: false
    }, config));
  }
};
export { loadFonts as default };